var map = {
	"./anamaria.jpg": 83,
	"./gabi.jpg": 84,
	"./guto.jpg": 85,
	"./lucia.jpg": 86,
	"./marcella.jpg": 87,
	"./mariana.jpg": 88,
	"./marina.jpg": 89,
	"./oscar.jpg": 90
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82;